import { getMembershipPriceProductInfo, createMembershipPriceCoupon, } from "@utils/api.js"
import { Decimal } from 'decimal.js'
import { cookie, copyString, } from "@utils/index.js"

// 产品优惠券
if (!customElements.get('v5-app-membership-price')) {
  customElements.define('v5-app-membership-price', class V5AppMembershipPrice extends HTMLElement {
    constructor() {
      super()

      // 获取 会员价 DOM
      this.variantWrap = document.querySelector(".variant-input-wrap")

      const {
        displayAutoDiscountPriceInStickyCart, spuId, productTitle, variantId, variantTitle, rulesText,
        claimCodeSuccessTipText, copyCodeSuccessTipText,

        endsInText, countdownLabelText, noLoginTitle, noLoginGuidedToLogin, noLoginBtnText, 
        loggedAndClaimedWithAutoApplyTitle, loggedAndClaimedWithAutoApplyBtnText,
        loggedAndClaimedWithNoAutoApplyTitle, loggedAndClaimedWithNoAutoApplyBtnText,
        loggedAndUnclaimedTitle, loggedAndUnclaimedBtnText, loggedApplyText, loggedTermsText,
      } = this.dataset

      // 是否显示自动优惠价格
      this.showAutoDiscount = displayAutoDiscountPriceInStickyCart === 'true'

      this.variants = [] // 初始化，所有变体信息为空
      this.spuInfo = [] // 初始化，spu信息为空
      this.curSkuInfo = {}  // 初始化，sku信息为空

      this.spuId = spuId
      this.productTitle = productTitle // SPU title
      this.variantId = variantId // 变体 ID
      this.discountAmount = 0 // 优惠金额

      // this.actId = actId // 活动 ID
      this.timer = null
      window.productMemberPriceInfo = [] // 存储会员价信息

      this.i18nText = {
        rulesText,
        claimCodeSuccessTipText,
        copyCodeSuccessTipText,

        endsInText,
        countdownLabelText: countdownLabelText.split(','),
        noLoginTitle,
        noLoginGuidedToLogin,
        noLoginBtnText,
        loggedAndClaimedWithAutoApplyTitle,
        loggedAndClaimedWithAutoApplyBtnText,
        loggedAndClaimedWithNoAutoApplyTitle,
        loggedAndClaimedWithNoAutoApplyBtnText,
        loggedAndUnclaimedTitle,
        loggedAndUnclaimedBtnText,
        loggedApplyText,
        loggedTermsText,
      }
    }
    connectedCallback() {
      // 获取所有变体信息
      if(document.querySelector('#membership-price-variant[type="application/json"]')) {
        const variantInfo = JSON.parse(document.querySelector('#membership-price-variant[type="application/json"]').textContent)
        this.variants = [].concat(variantInfo)
      } else if(document.querySelector('#membership-price-variants[type="application/json"]')) {
        this.variants = JSON.parse(document.querySelector('#membership-price-variants[type="application/json"]').textContent)
      }

      this.init()

      // 新 main-product 触发variant变化 - 改变当前变体
      if (document.querySelector('variant-fields')) {
        document.addEventListener('variantChangeEvent', e => {
          const currentVariant = e.detail.variant
          if (currentVariant) {
            this.variantId = currentVariant.id
            this.curSkuInfo = this.spuInfo.find(it => it.skuId.toString() === this.variantId.toString())

            setTimeout(() => this.initDOM(), 200)
          }
        })
      }
    }
    disconnectedCallback() {
      this.timer && clearTimeout(this.timer)
      window.productMemberPriceInfo = []
    }
    async init() {
      try {
        const data = await getMembershipPriceProductInfo({
          shopifyShopId: window.pageInfo.shopId,
          spuId: this.spuId,
          // actId: this.actId ? parseInt(this.actId.match(/\d+/)[0], 10) : null, // 活动 ID
        })

        if (data?.data) {
          this.spuInfo = data.data
          this.curSkuInfo = this.spuInfo.find(it => it.skuId.toString() === this.variantId.toString())

          // 登录成功后返回，自动获取 code 码
          if(this.curSkuInfo && window.pageInfo.customerInfo.id && sessionStorage.getItem('jk_sku_member_code')) {
            let _params = new URLSearchParams(window.location.search);
            const pendding = _params.get("pendding_member_code")
            if(pendding) {
              if (this.curSkuInfo.discountCode) {
                this.successCallback()
              } else {
                // 登录后自动复制，被浏览器禁止
                await this.updateSpuInfo(false)
              }

              // 更新 url
              _params.delete("pendding_member_code")
              const newUrl = window.location.origin + window.location.pathname + "?" + _params.toString();
              window.history.pushState({ path: newUrl }, "", newUrl);

              sessionStorage.removeItem('jk_sku_member_code')
            } else {
              sessionStorage.removeItem('jk_sku_member_code')
              this.initDOM()
            }
          } else {
            this.initDOM()
          }
        }
      } catch (err) {
        pushMessage(err.message, "warning");
        this.initDOM()
      }
    }
    // 获取选中的变体
    getSelectedVariant() {
      return this.variants.find(item => item.id.toString() === this.variantId.toString())
    }
    // 更新 #spuInfo
    async updateSpuInfo(needCopy) {
      const coupon = await createMembershipPriceCoupon({
        shopifyShopId: window.pageInfo.shopId,
        settingId: this.curSkuInfo.benefitId,
        activeId: this.curSkuInfo.activeId,
        skuId: this.curSkuInfo.skuId,
      })

      if (coupon.data) {
        this.curSkuInfo = coupon.data
        // 更新 #spuInfo
        this.spuInfo = this.spuInfo.map(item => {
          if (item.skuId === coupon.data.skuId) {
            return coupon.data
          }
          return item
        })

        // 是否需要复制
        if (needCopy) {
          copyString(this.curSkuInfo.discountCode, () => this.successCallback())
        } else {
          this.successCallback()
        }
      }
    }
    successCallback() {
      // 提示 copy 成功
      pushSuccessMessage(this.i18nText.claimCodeSuccessTipText)
    
      // 设置 cookie
      let d = new Date()
      d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000)) // 7天
      document.cookie = `discount_code=${this.curSkuInfo.discountCode};expires=${d.toGMTString()};path=/`

      this.initDOM()
    }
    async initDOM() {
      //【已登录】
      if (window.pageInfo?.customerInfo?.id) {
        // 初始化全局 productMemberPriceInfo 变量
        window.productMemberPriceInfo = window.productMemberPriceInfo || []

        this.spuInfo.forEach(item => {
          this.variants.forEach(variant => {
            if (item.skuId.toString() === variant.id.toString()) {
              const variantFields = document.querySelector('variant-fields')
              
              // 多变体
              if (variantFields) {
                const parentEl = variantFields?.querySelector(`input[data-id="${variant.id}"]`)?.parentElement
                // 更新 选中变体的价格显示
                const compared = this.showAutoDiscount ? variant.membership_price < variant.price : variant.membership_price < variant.shopify_price
                if (compared) {
                  const memberIds = window.productMemberPriceInfo.map(it => it.id.toString())
                  if (!memberIds.includes(variant.id.toString()) && item.discountCode) {
                    window.productMemberPriceInfo.push({
                      id: variant.id,
                      membership_price: variant.membership_price || variant.price, // 会员价
                      price: variant.price,
                      shopify_price: variant.shopify_price,
                      compare_at_price: variant.compare_at_price,
                      discountCode: item.discountCode,
                    })

                    // 更新变体内价格显示
                    if (parentEl?.querySelector('.option-price span.price')) {
                      parentEl.querySelector('.option-price span.price').textContent = formatMoney(variant.membership_price || variant.price)
                    }
  
                    // 更新划线价
                    if (
                      !parentEl?.querySelector('.option-price span.origin-price') &&
                      parentEl?.querySelector('.option-price') &&
                      variant.compare_at_price > variant.membership_price
                    ) {
                      parentEl.querySelector('.option-price').insertAdjacentHTML(
                        'beforeend',
                        `<span class="origin-price text-xs lg:text-sm text-black/65 line-through">
                          ${formatMoney(variant.compare_at_price)}
                        </span>`
                      )
                    }
                  }
                }
              }
              // 单变体
              else {
                // 更新 productMemberPriceInfo
                const compared = this.showAutoDiscount ? variant.membership_price < variant.price : variant.membership_price < variant.shopify_price
                if (compared) {
                  const memberIds = window.productMemberPriceInfo.map(it => it.id.toString())
                  if (!memberIds.includes(variant.id.toString()) && item.discountCode) {
                    window.productMemberPriceInfo.push({
                      id: variant.id,
                      membership_price: variant.membership_price || variant.price, // 会员价
                      price: variant.price,
                      compare_at_price: variant.compare_at_price,
                      discountCode: item.discountCode,
                    })
                  }
                }
              }
            }
          })
        })
      }

      if (!this.curSkuInfo || Object.keys(this.curSkuInfo)?.length === 0) {
        this.innerHTML = ''
        this.parentElement.style.display = 'none'

        // 更新会员价信息
        this.updateMemberPriceInfo()
        return
      }

      const {
        discountCode,  // 折扣码
        valueType,     // 折扣类型，0: 固定金额, 1: 百分比
        value,         // 折扣值
        imageType,     // 图片类型，0: 固定图片，1: 底图（数值作取值）
        imageUrl,      // 图片url
        ruleInfo,      // 规则信息
        showCountDown, // 是否显示倒计时
        countDownLimitDays, // 倒计时天数限制
        start: startDate,     // 活动开始时间
        end: endDate,       // 活动结束时间
      } = this.curSkuInfo

      // 计算优惠额
      this.discountAmount = this.calcDiscountPrice({ value, valueType, })

      // 如果显示倒计时
      if (showCountDown === 1 && endDate) {
        const serverTime = await this.getServerTime()
        // 如果服务端时间，大于 结束时间，则直接 return
        if (serverTime < new Date(startDate).getTime() || serverTime >= new Date(endDate).getTime()) {
          // 清空DOM
          this.innerHTML = ''
          this.parentElement.style.display = 'none'

          // 更新会员价信息
          this.updateMemberPriceInfo()
          return
        }

        // 提取时间计算逻辑为独立函数
        const calculateStartTime = (startDate, endDate, countDownLimitDays = 0) => {
          if (countDownLimitDays == 0) {
            return new Date(startDate).getTime();
          }

          const limitTime = countDownLimitDays * 86400000; // 24*60*60*1000
          const limitStartTime = new Date(endDate).getTime() - limitTime;

          return Math.max(limitStartTime, new Date(startDate).getTime());
        }

        /**
         * 1、显示倒计时
         * 2、新增逻辑, 到期多少天显示 逻辑
         * 3、倒计时开始：
         *      1、当countDownLimitDays为null时 取startDate
         *      1、当startDate大于endDate - countDownLimitDays 取startDate
         *      2、当startDate小于endDate - countDownLimitDays 取 endDate - countDownLimitDays
         */
        const startTime = calculateStartTime(startDate, endDate, countDownLimitDays);

        // 显示会员价 DOM
        this.showMembershipPriceDOM({
          discountCode,
          imageType,
          imageUrl,
          ruleInfo,
          isShowCountDown: startTime <= serverTime ? true : false,
          serverTime,
          startTime: new Date(startDate).getTime(),
          endTime: new Date(endDate).getTime(),
        })
      } else {
        // 显示会员价 DOM
        this.showMembershipPriceDOM({ discountCode, imageType, imageUrl, ruleInfo, isShowCountDown: false, })
      }
    }
    // 获取服务器时间
    async getServerTime() {
      return new Promise(async (resolve, reject) => {
        const { api, cr, shopId, } = window.pageInfo
        // 获取服务器时间
        const url = `${api}/osconsumerapi/v1/com/get-server-time?shopify_shop_id=${shopId || ''}&cr=${cr || ''}`
        const response = await fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          headers: { "Content-Type": "application/json", },
        });
        const { data: { datetime }, } = await response.json();
        const serverTime = new Date(datetime).getTime()
        resolve(serverTime)
      })
    }
    // 渲染 会员价 DOM
    showMembershipPriceDOM(payload) {
      this.renderMembershipPriceDOM(payload)
      this.parentElement.style.display = 'block'
    }
    renderMembershipPriceDOM(payload) {
      const { discountCode, isShowCountDown, serverTime, startTime, endTime, } = payload

      // 最新的 code 码
      const cookieCode = cookie.get('discount_code')

      this.innerHTML = this.renderDOM({ cookieCode, discountCode, isShowCountDown })
      
      // 初始化倒计时数据
      this.countdownDOM = this.querySelector('[data-count-down]');
      if (this.countdownDOM) {
        this.timer && clearTimeout(this.timer)
        this.initCountdownData({ serverTime, startTime, endTime });
      }

      const variantInfo = this.getSelectedVariant()
      
      const compared = this.showAutoDiscount ? variantInfo.membership_price < variantInfo.price : variantInfo.membership_price < variantInfo.shopify_price
      // 【已登录】 + 【已领取】 + 【有会员价】
      if (window.pageInfo?.customerInfo?.id && discountCode && compared) {
        // 更新购物车价格
        if (document.querySelector('v5-product-form')) {
          const addToCartBtn = document.querySelector('v5-product-form').querySelector('[name="add"]')
          const currentPrice = formatMoney(variantInfo?.membership_price || (this.showAutoDiscount ? variantInfo?.price : variantInfo?.shopify_price))
          addToCartBtn && (addToCartBtn.querySelector('span').textContent = `${currentPrice} ${window.pageInfo?.strings?.product?.inCart || ''}`)
        }

        // 更新吸底购物车
        if (document.querySelector('jky-v5-sticky-cart')) {
          const stickyCartPriceBtn = document.querySelector('jky-v5-sticky-cart').querySelector('#sticky_addToCart')
          const currentPrice = formatMoney(variantInfo?.membership_price || (this.showAutoDiscount ? variantInfo?.price : variantInfo?.shopify_price))
          stickyCartPriceBtn && (stickyCartPriceBtn.querySelector('span').textContent = `${currentPrice} ${window.pageInfo?.strings?.product?.inCart || ''}`)
        }
      }

      // 未登录
      if ($('[data-member-price-claim]').length > 0) {
        $('[data-member-price-claim]').off('click').on('click', (e) => {
          sessionStorage.setItem('jk_sku_member_code', this.variantId)
          let _params = new URLSearchParams(window.location.search)
          _params.set("pendding_member_code", "1")

          window?.jackeryLoginApp?.modalLogin({
            return_url: `${location.origin}${location.pathname}?${_params.toString()}`,
            register_act: 'MB-Register',
            tag: null
          })

          // 数据埋码
          gaPushDataLayer('5.0_products_details_page_user_clicks', {
            product_spu_name: this.productTitle, // 识别页面产品spu标题名称text
            module: "Member Discount", // 固定名称"Member Discount
            position: this.i18nText.noLoginTitle, // 取标题名称
            button_name: this.i18nText.noLoginBtnText, // 按钮内容text
          })
        })
      }
      
      // 已登录未领取
      if ($('[data-member-price-get]').length > 0) {
        $('[data-member-price-get]').off('click').on('click', async (e) => {
          e.currentTarget.classList.add('loading')
          try {
            // 更新 #spuInfo
            await this.updateSpuInfo(true)
          } catch (err) {
            pushMessage(err.message, "warning");
          } finally {
            setTimeout(() => e.currentTarget.classList.remove('loading'), 3000)

            // 数据埋码
            gaPushDataLayer('5.0_products_details_page_user_clicks', {
              product_spu_name: this.productTitle, // 识别页面产品spu标题名称text
              module: "Member Discount", // 固定名称"Member Discount
              position: this.querySelector('h4')?.querySelector('span:first-of-type')?.textContent?.trim(), // 取标题名称
              button_name: this.i18nText.loggedAndUnclaimedBtnText, // 按钮内容text
            })
          }
        })
      }

      // 注册 rules 点击事件
      if ($('[data-member-price-rules]').length > 0) {
        $('[data-member-price-rules]').off('click').on('click', (e) => {
          const popupHtml = `
            <div class="font-semibold text-[#242F20] mb-2 lg:mb-4 text-xl lg:text-3xl">
              ${this.i18nText.rulesText}
            </div>
            <div class="font-normal text-[#242F20]/65 text-sm lg:text-lg">
              ${this.curSkuInfo.ruleInfo}
            </div>
          `

          const jdsDialog = document.querySelector(`jds-dialog#v5-app-membership-price-rules-popup-${this.curSkuInfo.skuId}`);
          if (!jdsDialog) {
            const dialog = document.createElement('jds-dialog');
            dialog.id = `v5-app-membership-price-rules-popup-${this.curSkuInfo.skuId}`
            dialog.style = '--jds-dialog-index:999999999'
            dialog.innerHTML = `<div class="jds-rte">${popupHtml}</div>`;
            document.body.appendChild(dialog);
          }

          // 打开弹窗
          document.querySelector(`jds-dialog#v5-app-membership-price-rules-popup-${this.curSkuInfo.skuId}`)?.setAttribute('open', true)

          // 数据埋码
          gaPushDataLayer('5.0_products_details_page_user_clicks', {
            product_spu_name: this.productTitle, // 识别页面产品spu标题名称text
            module: "Member Discount", //固定名称Member Discount
            position: this.querySelector('h4')?.querySelector('span:first-of-type')?.textContent?.trim(), // 识别优惠券标题
            button_name: this.i18nText.loggedTermsText, // 识别按钮文本
          })
        })
      }

      // 注册 copy 事件
      if ($('[data-member-price-copy]').length > 0) {
        $('[data-member-price-copy]').off('click').on('click', (e) => {
          this.registerCopyEvent(e, true)

          // 数据埋码
          gaPushDataLayer('5.0_products_details_page_user_clicks', {
            product_spu_name: this.productTitle, // 识别页面产品spu标题名称text
            module: "Member Discount", //固定名称Member Discount
            position: this.querySelector('h4')?.querySelector('span:first-of-type')?.textContent?.trim(), // 识别优惠券标题
            button_name: e.currentTarget.textContent, // 识别按钮文本
          })
        })
      }
    }
    // 注册 copy 事件
    registerCopyEvent(e, needSetCookie) {
      const { code, copiedText, } = e.currentTarget.dataset
      if (code) {
        copyString(code, () => {
          // 是否需要 set cookie
          if (needSetCookie) {
            // 提示 copy 成功
            pushSuccessMessage(this.i18nText.copyCodeSuccessTipText)

            // 设置 cookie
            let d = new Date()
            d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000)) // 7天
            document.cookie = `discount_code=${code};expires=${d.toGMTString()};path=/`

            // 更新文案
            e.currentTarget.textContent = copiedText
          } else {
            // 提示 copy 成功
            pushSuccessMessage(this.i18nText.copyCodeSuccessTipText)
          }
        })
      }
    }
    // 计算优惠价格
    calcDiscountPrice({value, valueType}) {
      // 固定减免金额
      if (valueType === 0) {
        const priceStr = formatMoney(new Decimal(value).mul(100).toNumber(), window.pageInfo?.currency?.money_format)
        return priceStr.replace(/\.00$|,00$/, '')
      }

      // 百分比减免
      return value + '%'
    }
    // 渲染 DOM
    renderDOM({ cookieCode, discountCode, isShowCountDown }) {
      // 已登录
      if (window.pageInfo?.customerInfo?.id) {
        return `
          <h4 class="text-base leading-7 lg:text-2xl lg:leading-9 -my-0.5">
            <span class="text-primary font-semibold text-base lg:text-2xl">
              ${discountCode
                ? `${cookieCode === discountCode ? this.i18nText.loggedAndClaimedWithAutoApplyTitle.replace('{price}', this.discountAmount) : this.i18nText.loggedAndClaimedWithNoAutoApplyTitle.replace('{price}', this.discountAmount)}`
                : `${this.i18nText.loggedAndUnclaimedTitle.replace('{price}', this.discountAmount)}`
              }
            </span>
            ${discountCode ? `<span class="font-semibold text-black bg-[#E8E8E5] text-lg lg:text-2xl px-2">${discountCode}</span>` : ''}
            ${!discountCode
              ? `
                <button
                  class="jky-v5-button-ghost float-right appearance-none bg-transparent flex items-center font-semibold text-[#242F20] text-lg lg:text-2xl underline underline-offset-4"
                  data-member-price-get
                >${this.i18nText.loggedAndUnclaimedBtnText}</button>
                `
              : `
                <button
                  class="float-right appearance-none bg-transparent flex items-center font-semibold text-[#242F20] text-lg lg:text-2xl underline underline-offset-4"
                  data-member-price-copy
                  data-code="${discountCode}"
                  data-copied-text="${this.i18nText.loggedAndClaimedWithAutoApplyBtnText}"
                >
                  ${cookieCode === discountCode ? this.i18nText.loggedAndClaimedWithAutoApplyBtnText : this.i18nText.loggedAndClaimedWithNoAutoApplyBtnText}
                </button>
              `
            }
          </h4>
          ${isShowCountDown
            ? `<div class="w-full flex flex-wrap items-center gap-x-1" data-count-down>
                <span class="text-black/65 text-sm lg:text-base mr-1 lg:mr-3">${this.i18nText.endsInText}</span>
                <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 ${this.i18nText.countdownLabelText[0]?.trim() || ''}</span>
                <span class="text-[#242F20] font-semibold text-sm lg:text-lg -mt-0.5">:</span>
                <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 ${this.i18nText.countdownLabelText[1]?.trim() || ''}</span>
                <span class="text-[#242F20] font-semibold text-sm lg:text-lg -mt-0.5">:</span>
                <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 ${this.i18nText.countdownLabelText[2]?.trim() || ''}</span>
                <span class="text-[#242F20] font-semibold text-sm lg:text-lg -mt-0.5">:</span>
                <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 ${this.i18nText.countdownLabelText[3]?.trim() || ''}</span>
              </div>`
            : ''
          }
          ${discountCode
            ? `
              <div class="flex flex-col gap-y-1 lg:gap-y-2">
                ${this.i18nText.loggedApplyText
                  ? `<p class="w-full text-left text-[#242F20] text-sm lg:text-base">${this.i18nText.loggedApplyText}</p>`
                  : ''
                }
                ${this.i18nText.loggedTermsText
                  ? `<button data-member-price-rules class="w-fit text-left appearance-none bg-transparent text-black/65 text-sm lg:text-base underline underline-offset-4">${this.i18nText.loggedTermsText}</button>`
                  : ''
                }
              </div>
            `
            : ''
          }
        `
      }

      // 引导登录
      const guideHTML = this.i18nText.noLoginGuidedToLogin.replace('$btn', `
        <button data-member-price-claim class="appearance-none bg-transparent text-[#242F20] active:text-primary visited:text-[#242F20] text-sm lg:text-base underline underline-offset-4">
          ${this.i18nText.noLoginBtnText}
        </button>
      `)

      // 未登录
      return `
        <h4 class="text-primary font-semibold text-base lg:text-2xl">${this.i18nText.noLoginTitle}</h4>
        ${isShowCountDown
          ? `<div class="w-full flex flex-wrap items-center gap-x-1" data-count-down>
              <span class="text-black/65 text-sm lg:text-base mr-1 lg:mr-3">${this.i18nText.endsInText}</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 Days</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg -mt-0.5">:</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 Hours</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg -mt-0.5">:</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 Mins</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg -mt-0.5">:</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 Secs</span>
            </div>`
          : ''
        }
        <p class="w-full text-left text-[#242F20] text-sm lg:text-base">${guideHTML}</p>
      `
    }
    // 倒计时初始化
    async initCountdownData({ serverTime, startTime, endTime, }) {
      if (serverTime >= startTime) {
        this.tick(endTime, serverTime)
      } else {
        // 移除DOM
        this.parentElement.removeChild(this)
      }
    }
    // 倒计时 span
    renderCountdownSpan(days, hours, minutes, seconds) {
      const style = 'text-[#242F20] font-semibold text-sm lg:text-lg'

      return `
        <span class="text-black/65 text-sm lg:text-base mr-1 lg:mr-3">${this.i18nText.endsInText}</span>
        <span class="${style}">${days || ''} ${this.i18nText.countdownLabelText[0]?.trim() || ''}</span>
        <span class="${style} -mt-0.5">:</span>
        <span class="${style}">${hours || ''} ${this.i18nText.countdownLabelText[1]?.trim() || ''}</span>
        <span class="${style} -mt-0.5">:</span>
        <span class="${style}">${minutes || ''} ${this.i18nText.countdownLabelText[2]?.trim() || ''}</span>
        <span class="${style} -mt-0.5">:</span>
        <span class="${style}">${seconds || ''} ${this.i18nText.countdownLabelText[3]?.trim() || ''}</span>
      `
    }
    // 倒计时
    tick(target, current) {
      const leftTime = (target - current) / 1000
      let days, hours, minutes, seconds

      // 倒计时结束
      if (leftTime <= 0) {
        this.timer && clearTimeout(this.timer)

        // 清空 DOM
        this.innerHTML = ''
        this.parentElement.style.display = 'none'

        // 更新会员价信息
        this.updateMemberPriceInfo()
      } else {
        days = String(parseInt(leftTime / 60 / 60 / 24)).padStart(2, '0')
        hours = String(parseInt(leftTime / 60 / 60 % 24)).padStart(2, '0')
        minutes = String(parseInt(leftTime / 60 % 60)).padStart(2, '0')
        seconds = String(parseInt(leftTime % 60)).padStart(2, '0')

        if (this.countdownDOM) {
          this.countdownDOM.innerHTML = this.renderCountdownSpan(days, hours, minutes, seconds)
        }

        this.timer = setTimeout(() => this.tick(target, current + 1000), 1000)
      }
    }
    // 更新会员价信息
    updateMemberPriceInfo() {
      // 【已登录】，更新【价格】、【划线价】
      if (window.pageInfo?.customerInfo?.id) {
        const variantInfo = this.getSelectedVariant()

        // 更新 window.productMemberPriceInfo
        window.productMemberPriceInfo = window.productMemberPriceInfo.filter(item => item.id.toString() !== variantInfo.id.toString())
        // 更新 spuInfo
        this.spuInfo = this.spuInfo.filter(item => item.skuId.toString() !== variantInfo.id.toString())
          
        if (variantInfo.membership_price < variantInfo.price) {
          // 更新 【选中变体的价格】、添加【选中变体的划线价】
          if (document.querySelector('variant-fields')) {
            const parentEl = document.querySelector(`variant-fields input[data-id="${variantInfo.id}"]`)?.parentElement
            if (parentEl?.querySelector('.option-price span.price')) {
              parentEl.querySelector('.option-price span.price').textContent = formatMoney(variantInfo.price)
            }

            // 删除 划线价
            if (parentEl?.querySelector('.option-price span.origin-price')) {
              if (variantInfo.compare_at_price === variantInfo.price) {
                parentEl.querySelector('.option-price').removeChild(parentEl.querySelector('.option-price span.origin-price'))
              }
            }
          }
        }

        const compared = this.showAutoDiscount ? variantInfo.membership_price < variantInfo.price : variantInfo.membership_price < variantInfo.shopify_price
        if (compared) {
          // 更新购物车价格
          if (document.querySelector(`v5-product-form`)) {
            const addToCartPriceDOM = document.querySelector(`v5-product-form`).querySelector('[name="add"]')?.querySelector('span')
            addToCartPriceDOM && (addToCartPriceDOM.textContent = `${formatMoney(this.showAutoDiscount ? variantInfo.price : variantInfo.shopify_price)} ${window.pageInfo?.strings?.product?.inCart || ''}`)
          }
          
          // 更新 吸底购物车【价格】、【划线价】、【折扣】
          if (document.querySelector('jky-v5-sticky-cart')) {
            const spanPriceDOM = document.querySelector('jky-v5-sticky-cart')?.querySelector('#sticky_addToCart')?.querySelector('span')
            spanPriceDOM && (spanPriceDOM.textContent = `${formatMoney(this.showAutoDiscount ? variantInfo.price : variantInfo.shopify_price)} ${window.pageInfo?.strings?.product?.inCart || ''}`)
          }
        }
      }
    }
  })
}
